// All parameters in metric system (cm and kg)
export const MIN_HEIGHT = 100;
export const MAX_HEIGHT = 250;
export const MIN_WEIGHT = 0;
export const MAX_WEIGHT = 200;
